import { render, staticRenderFns } from "./OrderOView.vue?vue&type=template&id=4165eff0&"
import script from "./OrderOView.vue?vue&type=script&lang=ts&"
export * from "./OrderOView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports